import { combineReducers } from "redux";
import authReducer from "./AuthReducer";
import suFilters from "../../features/su/state/filtersSlice";
// import companyReducer from "./CompanyReducer";

const combinedReducer = combineReducers({
  authReducer,
  suFilters,
//   companyReducer,
});

export default combinedReducer;